import { encode } from 'uqr'

// One <path> of 1x1 squares. Always dark-on-light: inverted codes scan badly on some phones.
export function qrSvg(text) {
  const { data, size } = encode(text, { ecc: 'M', border: 2 })
  let d = ''
  data.forEach((row, y) => row.forEach((on, x) => on && (d += `M${x} ${y}h1v1h-1z`)))
  return `<svg viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges" role="img" aria-label="QR code to join this group"><rect width="${size}" height="${size}" fill="#fff"/><path d="${d}" fill="#000"/></svg>`
}
